
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetopandharpurcabservice() {



    const cardData =
    {
        keyword: 'Pune to Pandharpur Cab Services',
        heading: 'S9 Travels: Pune to Pandharpur Cab Services',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable cab services from Pune to Pandharpur. Whether you are visiting for a religious pilgrimage or exploring the historical sites, we provide a smooth and hassle-free journey. Pandharpur is located around 200 km from Pune, and the journey typically takes about 4 to 5 hours by road. With our well-maintained fleet and professional drivers, you can enjoy a comfortable ride with top-notch amenities and customer-centric service.',

        top: 'Top Places to Visit in Pandharpur with S9 Travels',

        "topPlaces": [
            {
              "title": "Vithoba Temple",
              "description": "The Vithoba Temple is the main attraction in Pandharpur and one of the holiest places for devotees of Lord Vithoba (a form of Lord Krishna). The temple is known for its magnificent architecture and religious significance, drawing pilgrims from all over the country."
            },
            {
              "title": "Pandharpur Lake (Chandrabhaga River)",
              "description": "The Pandharpur Lake, also known as the Chandrabhaga River, is an important site for devotees. According to Hindu mythology, the river has the power to wash away sins, and many devotees take a dip in the waters as part of their pilgrimage."
            },
            {
              "title": "Bhuikot Fort",
              "description": "Bhuikot Fort is a historic site located on the outskirts of Pandharpur. The fort dates back to the 14th century and offers visitors a glimpse into the region's rich history. The fort's architecture and surrounding landscapes make it an interesting place for history enthusiasts."
            },
            {
              "title": "Kusumavati River",
              "description": "Kusumavati River is another sacred river in Pandharpur. The river is associated with several religious events and holds great importance for pilgrims. It is a peaceful spot, ideal for relaxing and offering prayers."
            },
            {
              "title": "Yamai Temple",
              "description": "The Yamai Temple, dedicated to Goddess Yamai, is another significant temple in Pandharpur. Situated on the banks of the river, it offers a serene atmosphere for worshippers seeking peace and blessings."
            },
            {
              "title": "Pundalik Temple",
              "description": "Pundalik Temple is dedicated to the saint Pundalik, a revered figure in the Bhakti movement. The temple is known for its historical significance and spiritual atmosphere, making it a must-visit for those interested in Maharashtra's religious heritage."
            },
            {
              "title": "Tuljabhavani Temple",
              "description": "Located a short distance from Pandharpur, the Tuljabhavani Temple is dedicated to Goddess Tuljabhavani, the protector of the region. The temple is known for its grandeur and attracts devotees seeking the goddess's blessings."
            },
            {
              "title": "Vitthal Rakhumai Temple",
              "description": "Located near the Vithoba Temple, the Vitthal Rakhumai Temple is dedicated to Lord Vitthal and his consort Rakhumai. This temple is a peaceful place for prayer and offers a serene environment for meditation."
            }
          ],

          "services": [
            {
              "name": "Book Pune to Pandharpur Taxi",
              "description": "S9 Travels offers reliable and comfortable taxi services from Pune to Pandharpur, ensuring a smooth and peaceful journey. Whether you're visiting for religious purposes or leisure, we guarantee a hassle-free experience."
            },
            {
              "name": "Book Pune to Pandharpur Cab Service",
              "description": "Book your Pune to Pandharpur cab with S9 Travels for a convenient and comfortable ride. Our professional drivers and well-maintained vehicles ensure you reach your destination with ease."
            },
            {
              "name": "Pune to Pandharpur One-Way Taxi",
              "description": "For a direct and convenient journey, book a one-way taxi from Pune to Pandharpur with S9 Travels. Our one-way services are affordable, ensuring that your trip is simple and cost-effective."
            },
            {
              "name": "Pune to Pandharpur Round Trip",
              "description": "S9 Travels provides flexible round-trip taxi services from Pune to Pandharpur. Enjoy a comfortable ride both ways with our experienced drivers, ensuring you have a stress-free and pleasant journey."
            },
            {
              "name": "Pune to Pandharpur Taxi Fare",
              "description": "At S9 Travels, we offer affordable and transparent taxi fares for your journey from Pune to Pandharpur. Our pricing is clear with no hidden charges, giving you peace of mind while planning your trip."
            },
            {
              "name": "Pune to Pandharpur Car Rental",
              "description": "Looking for car rental services to Pandharpur from Pune? S9 Travels offers a range of vehicles for your journey. Choose from well-maintained cars and enjoy a comfortable and flexible ride to your destination."
            },
            {
              "name": "Pune to Pandharpur Luxury Taxi",
              "description": "Travel in style with our luxury taxi services from Pune to Pandharpur. Enjoy a premium experience with added comfort and extra space during your trip to the sacred town of Pandharpur."
            },
            {
              "name": "Pune to Pandharpur Efficient Taxi",
              "description": "For a budget-friendly option, S9 Travels offers Efficient Taxi services from Pune to Pandharpur. Share the ride with others and enjoy a comfortable, cost-effective journey to this spiritual destination."
            },
            {
              "name": "Pandharpur Car Hire from Pune",
              "description": "S9 Travels provides reliable car hire services from Pune to Pandharpur. Rent a vehicle for your convenience and enjoy a relaxed journey with a professional driver."
            },
            {
              "name": "Pandharpur Temple Taxi from Pune",
              "description": "Planning to visit the Pandharpur Temple? S9 Travels offers specialized Pandharpur Temple taxi services from Pune. Our drivers are familiar with the best routes, ensuring a quick, smooth, and safe journey."
            },
            {
              "name": "Pandharpur Religious Tour Cab",
              "description": "S9 Travels offers Pandharpur religious tour cabs for pilgrims looking to visit the sacred town from Pune. Book a comfortable ride for your spiritual journey to this famous pilgrimage site."
            },
            {
              "name": "Affordable Pune to Pandharpur Taxi",
              "description": "S9 Travels offers affordable taxi services from Pune to Pandharpur, ensuring you get the best value for your journey. No hidden fees, just comfortable and affordable rides."
            },
            {
              "name": "Private Cab for Pandharpur from Pune",
              "description": "For a more personalized and private journey, book a private cab from Pune to Pandharpur. Enjoy a comfortable, private ride with our experienced drivers."
            },
            {
              "name": "Group Taxi Booking for Pandharpur",
              "description": "Traveling in a group? S9 Travels provides group taxi booking services for your trip to Pandharpur. We offer spacious vehicles for a comfortable journey with your family or friends."
            }
          ],


"tableData": [
  ["Book Pune To Pandharpur Taxi", "Book Pune To Pandharpur Cab Service"],
  ["Book Pune To Pandharpur One-Way Taxi", "Book Pune To Pandharpur Round Trip"],
  ["Book Pune To Pandharpur Taxi Fare", "Book Pune To Pandharpur Car Rental"],
  ["Book Pune To Pandharpur Luxury Taxi", "Book Pune To Pandharpur Efficient Taxi"],
  ["Pandharpur Car Hire from Pune", "Pandharpur Temple Taxi from Pune"],
  ["Pandharpur Religious Tour Cab", "Affordable Pune to Pandharpur Taxi"],
  ["Private Cab for Pandharpur from Pune", "Group Taxi Booking for Pandharpur"]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the significance of time when planning your pilgrimage to Pandharpur. Whether you're heading for a religious trip or a peaceful visit, we ensure timely pickups and drop-offs, so you can have a smooth, hassle-free experience."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a variety of well-maintained vehicles including sedans, SUVs, and premium cars for your journey from Pune to Pandharpur. Our vehicles are designed for comfort, with spacious interiors, air conditioning, and ample luggage space, ensuring a relaxing ride."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are skilled, experienced, and well-versed in the best routes to Pandharpur. They prioritize your comfort and safety, ensuring a smooth and secure journey, so you can focus on your spiritual journey."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Pandharpur trip. We provide a clear breakdown of costs with no hidden charges, ensuring that you know exactly what to expect, making your trip budget-friendly and stress-free."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking, ensuring a secure and comfortable journey to Pandharpur."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "Whether you're planning an early morning trip or a late-night return, S9 Travels is available 24/7 to meet your needs. Our customer service team is always ready to assist with booking, questions, or any other assistance you require."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking a cab for your Pune to Pandharpur trip is simple and convenient with S9 Travels. You can easily book through our website or mobile app, or you can contact our customer service team for personalized assistance and guidance."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you are visiting Pandharpur for religious purposes or leisure, we offer customized travel packages that suit your preferences. Let us know your needs, and we’ll make the trip special and memorable for you."
  }
]


















    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Pandharpur cab with S9 Travels?',
            answer: 'Booking a cab is easy! You can book online through our website or app, or contact our customer service team for personalized assistance and help with planning your trip.',
          },
          {
            question: 'What types of vehicles are available for the Pune to Pandharpur trip?',
            answer: 'We offer a range of vehicles, including sedans, SUVs, and premium cars, all well-maintained to provide comfort and safety during your journey to Pandharpur.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel to Pandharpur?',
            answer: 'Yes, all our drivers are highly experienced in long-distance travel. They know the best routes to Pandharpur and ensure a smooth and safe journey.',
          },
          {
            question: 'How do I pay for my Pune to Pandharpur cab rental?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payment via our app, making it easy and convenient for you to pay for your ride.',
          },
          {
            question: 'Can I book a round-trip from Pune to Pandharpur?',
            answer: 'Yes, we can arrange a round-trip for you. Simply provide us with your return details, and we’ll ensure a smooth and comfortable return journey.',
          },
          {
            question: 'Are there any extra charges for waiting or detours during the trip?',
            answer: 'Any additional charges, like waiting time or detours, will be communicated to you upfront, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Pandharpur?',
            answer: 'Yes, we offer sightseeing tours in and around Pandharpur. Explore the famous Vitthal Temple, and other attractions, with the help of our experienced drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Pandharpur cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional luggage or specific requirements, please inform us at the time of booking, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate or group travel to Pandharpur?',
            answer: 'Yes, we offer corporate and group travel services to Pandharpur. Whether it’s for a corporate trip or a group of devotees, we ensure a comfortable and safe journey for everyone.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Pandharpur journey?',
            answer: 'S9 Travels guarantees a reliable, comfortable, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. We prioritize your safety and comfort, ensuring a smooth and memorable trip to Pandharpur.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Ravi Shinde',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab with S9 Travels for my trip to Pandharpur. The driver was professional, and the vehicle was clean and comfortable. I had a smooth and pleasant journey, and I highly recommend their services!”',
        },
        {
          name: 'Mrs. Anjali Deshpande',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family visited Pandharpur with S9 Travels, and it was a wonderful experience. The vehicle was spacious and clean, and the driver was very courteous. We felt safe and comfortable throughout the journey.”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune To Pandharpur Cab Service",
        "description": "Book Pune to Pandharpur cab services with S9 Travels. Whether you need a one-way taxi, round-trip, luxury taxi, or car rental, we offer affordable and reliable transport to Pandharpur Temple. Book private cabs, Efficient Taxis, or group bookings for a comfortable and spiritual journey to Pandharpur from Pune.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
    
      
      
      
      


    return (
        <div>
           <Helmet>
        <title>Pune To Pandharpur Cab Service | Affordable Taxi & Car Rentals | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune to Pandharpur taxi services, one-way, round-trip, luxury taxis, Efficient Taxis, and car rentals with S9 Travels. Get the best fares for your Pandharpur Temple tour, private cab bookings, and group bookings for a religious journey from Pune." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/22.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetopandharpurcabservice;